module.exports = __webpack_public_path__ + "img/bg_login.e4d6f5f1.jpg";